export default __webpack_public_path__ + "static/media/default-user.8ad7ad25.png";